// extracted by mini-css-extract-plugin
export default {"item":"Item_item__T2ttK","content":"Item_content__B-Dl7","label":"Item_label__6HXUT","error":"Item_error__fSOFk"};